export default __webpack_public_path__ + "dd41902d1f64da3e152f05886ce6ab61.svg";